import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { FiZap, FiAlertOctagon, FiActivity } from "react-icons/fi";
import api from "../services/api";
import SearchResultCard from "../components/SearchResultCard";

const FlashDealsPage = () => {
  const { t } = useTranslation();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchFlashDeals = async () => {
      setLoading(true);
      setError("");
      try {
        const response = await api.get("/products/flash-deals/");
        setProducts(response.data.results || response.data);
      } catch (err) {
        setError("Failed to load flash deals.");
      } finally {
        setLoading(false);
      }
    };
    fetchFlashDeals();
  }, []);

  return (
    <div className="min-h-screen bg-theme-bg">
      {/* ── MINIMAL HEADER ── */}
      <div className="max-w-7xl mx-auto px-4 pt-12 pb-8 border-b border-component-border">
        <h1 className="text-3xl md:text-5xl font-black text-theme-text tracking-tight font-display uppercase">
          {t("flashDealsPage.title", "Flash Deals")}
        </h1>
        <p className="text-[10px] font-black text-theme-muted uppercase tracking-[0.2em] mt-3">
           {t("flashDealsPage.subtitle", "Don't miss out! The best prices on top products, available for a limited time.")}
        </p>
      </div>

      <div className="max-w-7xl mx-auto px-4 py-12">
        {loading ? (
          <div className="flex flex-col items-center justify-center py-20 gap-8 animate-fade-in">
            <div className="relative">
               <div className="w-24 h-24 border-4 border-chafadi-primary/20 border-t-chafadi-primary rounded-full animate-spin" />
               <FiActivity className="absolute inset-0 m-auto text-chafadi-primary animate-pulse" size={24} />
            </div>
            <p className="text-[10px] font-black text-theme-muted uppercase tracking-[0.5em] animate-pulse">Loading Deals...</p>
          </div>
        ) : error ? (
          <div className="bg-rose-50 border border-rose-100 p-12 rounded-[48px] text-center space-y-6 max-w-2xl mx-auto shadow-2xl animate-fade-in">
            <div className="w-20 h-20 bg-rose-500 text-white rounded-3xl flex items-center justify-center mx-auto shadow-xl">
              <FiAlertOctagon size={40} />
            </div>
            <h4 className="text-xl font-black text-theme-text uppercase tracking-widest leading-relaxed">{error}</h4>
            <button onClick={() => window.location.reload()} className="px-10 h-14 bg-theme-text text-white rounded-full text-xs font-black uppercase tracking-widest hover:bg-black transition-all">Try Again</button>
          </div>
        ) : products.length > 0 ? (
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4 animate-fade-in">
            {products.map((product) => (
              <div key={product.id} className="transition-all hover:-translate-y-2 duration-500">
                <SearchResultCard product={product} />
              </div>
            ))}
          </div>
        ) : (
          <div className="bg-white rounded-[60px] border border-component-border p-24 text-center shadow-2xl shadow-gray-200/20 max-w-4xl mx-auto animate-fade-in">
            <div className="w-32 h-32 bg-theme-bg rounded-full flex items-center justify-center mx-auto mb-10 border border-component-border shadow-inner">
              <FiZap size={64} className="text-theme-muted/20" />
            </div>
            <h4 className="text-3xl font-black text-theme-text mb-4 uppercase tracking-tighter font-display">
              {t("flashDealsPage.noDeals", "No Deals Right Now")}
            </h4>
            <p className="text-sm font-medium text-theme-muted uppercase tracking-[0.2em] leading-relaxed max-w-sm mx-auto">
              {t("flashDealsPage.checkBack", "We don't have any active flash deals at the moment. Please check back later.")}
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default FlashDealsPage;